import {
        FETCH_MENU_TOPO,
        FETCH_SUB_MENU,
        FETCH_CHECK_SELECT,
        ACTION_TOPO,
        ACTION_BG,
        ACTION_MOAL} from '../actions/scopoAction';

const INITIAL_STATE = {
                        allListaMenu    : [],
                        allListaSubMenu : [],
                        checkSelect     : null,
                        actionModal     : false,
                        actionTopo      : false,
                        actionBg        : false                        
                      };

export default function(state = INITIAL_STATE,action){

switch (action.type) {

    case FETCH_MENU_TOPO:
 
      return { ...state, allListaMenu : (action.payload?action.payload:[]) }

    case FETCH_SUB_MENU:
 
      return { ...state, allListaSubMenu : (action.payload?action.payload:[]) }

    case FETCH_CHECK_SELECT:
   
      return { ...state, checkSelect : action.payload }

    case ACTION_MOAL:
 
      return { ...state, actionModal : action.payload }

    case ACTION_TOPO:

      return { ...state, actionTopo : action.payload }

    case ACTION_BG:

       return { ...state, actionBg : action.payload }

  

    default:
       return state;
  
}

}





// WEBPACK FOOTER //
// ./src/reducers/reducer_scopo.js